import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

const PinInput = React.forwardRef((props, ref) => {
  const {
    labelId,
    value,
    onChange,
    labelStyle,
    controlsStyle,
    className,
    onSendClick,
  } = props;

  return (
    <div className={classnames(className, 'control-group')}>
      <label
        className={'control-label control-label--blue'}
        style={labelStyle}
        htmlFor="clinicPin"
      >
        <FormattedMessage id={labelId}>{(txt) => <>{txt}</>}</FormattedMessage>
      </label>
      <div className={'controls'} style={controlsStyle}>
        <input
          ref={ref}
          id="clinicPin"
          name="pin"
          pattern="[0-9]{4}"
          maxLength="4"
          type={'password'}
          value={value}
          style={{
            fontSize: '32px',
            letterSpacing: '3px',
            width: '64px',
            textAlign: 'center',
          }}
          onChange={onChange}
        />
      </div>
    </div>
  );
});

export default PinInput;
